import SubSections from '~/constants/vdp/subSections';
import InfoSash from './InfoSash';

type OwnProps = { factoryUpgradesMsrp: number };

export default function FactoryUpgradesBadge({
  factoryUpgradesMsrp
}: OwnProps) {
  const badgeText = `$${factoryUpgradesMsrp.toLocaleString()} in factory upgrades`;
  const compactBadgeText = `$${factoryUpgradesMsrp.toLocaleString()} factory upgrades`;

  return (
    <InfoSash
      adobeId={null}
      analyticsDescription="factory upgrades"
      bgColor="bg-background-primary-subtle"
      compactText={compactBadgeText}
      leadingText="Includes:"
      section={SubSections.FactoryUpgrades}
      testId="factory-upgrades-badge"
      text={badgeText}
    />
  );
}
